const HEADER_FORM = 'header-form';

export { HEADER_FORM };
